// extracted by mini-css-extract-plugin
module.exports = {"empty-box":"empty-box__2ImBG","box":"box__1mgWs","title":"title__2lRCS","body":"body__2nuap","button-wrapper":"button-wrapper__315QG","button":"button__11mOU","note":"note__J3uNm"};